import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pageservice from './Pageservice'
import Service2 from '../Home/Service2'
import Booking from '../Home/Booking'
import Testimonial from '../Home/Testimonial'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'


function AllService() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pageservice/>
        <Service2/>
        <Booking/>
        <Testimonial/>
        <Footer/>
    </CartProvider>
  )
}

export default AllService